import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { scrollToId } from '../lib/scroll';

const LINKS = [
    { label: 'Por qué conmigo', id: '#metodo', testid: 'nav-metodo-link' },
    { label: 'Modalidades', id: '#modalidades', testid: 'nav-modalidades-link' },
    { label: 'Contacto', id: '#contacto', testid: 'nav-contacto-link' },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const goTo = (id) => {
        setOpen(false);
        if (location.pathname !== '/') {
            navigate('/');
            setTimeout(() => scrollToId(id), 350);
        } else {
            scrollToId(id);
        }
    };

    return (
        <header className="fixed top-0 left-0 right-0 z-50 border-b border-ink/10 bg-paper/90 backdrop-blur-md" data-testid="navbar">
            <div className="max-w-[1080px] mx-auto px-6 h-[72px] flex items-center justify-between">
                <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-2.5">
                    <img src="/logo-ah.png" alt="Logo Adriana Hernández" className="h-10 w-auto" data-testid="nav-logo-image" />
                    <span className="font-serif italic font-medium text-xl text-ink tracking-wide">Personal Trainer</span>
                </Link>
                <nav className="hidden md:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <button key={l.id} data-testid={l.testid} onClick={() => goTo(l.id)} className="text-sm text-ink/75 hover:text-ink transition-colors">
                            {l.label}
                        </button>
                    ))}
                    <Link to="/sobre-mi" data-testid="nav-sobre-mi-link" className="text-sm text-ink/75 hover:text-ink transition-colors">
                        Sobre mí
                    </Link>
                    <button
                        data-testid="nav-cta-button"
                        onClick={() => goTo('#contacto')}
                        className="rounded-full bg-rose text-paper px-5 py-2.5 text-sm font-semibold hover:bg-roselight active:scale-95 transition"
                    >
                        Quiero comenzar
                    </button>
                </nav>
                <button data-testid="nav-menu-toggle" className="md:hidden text-ink" onClick={() => setOpen(!open)} aria-label="Menú">
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>
            <AnimatePresence>
                {open && (
                    <motion.nav
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        className="md:hidden border-t border-ink/10 bg-paper overflow-hidden"
                        data-testid="nav-mobile-menu"
                    >
                        <div className="px-6 py-6 flex flex-col gap-5 text-base">
                            {LINKS.map((l) => (
                                <button key={l.id} data-testid={`${l.testid}-mobile`} onClick={() => goTo(l.id)} className="text-left text-ink/75">
                                    {l.label}
                                </button>
                            ))}
                            <Link to="/sobre-mi" data-testid="nav-sobre-mi-link-mobile" onClick={() => setOpen(false)} className="text-ink/75">
                                Sobre mí
                            </Link>
                            <button
                                data-testid="nav-cta-button-mobile"
                                onClick={() => goTo('#contacto')}
                                className="rounded-full bg-rose text-paper px-5 py-2.5 font-semibold w-fit"
                            >
                                Quiero comenzar
                            </button>
                        </div>
                    </motion.nav>
                )}
            </AnimatePresence>
        </header>
    );
};
